// JS file for ArticleItem
